/**
 * File social-proof-carousel.js
 *
 * Handles Swiper Carousels for the homepage social proof carousel.
 */

// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/no-unresolved */
import Swiper, { Navigation } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';

document.addEventListener( 'DOMContentLoaded', function () {
	if ( document.querySelectorAll( '.social-proof-carousel' ).length ) {
		new Swiper( '.social-proof-carousel', {
			modules: [ Navigation ],
			cssMode: true,
			speed: 500,
			loop: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				slidesPerView: 1,
				900: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 40,
				},
			},
		} );

		function updateTileText() {
			const slide = document.querySelector(
				'.social-proof-carousel .swiper-slide'
			);
			const slideWidth = slide.clientWidth;
			const fontSize = slideWidth * 0.75 * 0.075;
			document
				.querySelectorAll( '.social-proof-carousel .swiper-slide p' )
				.forEach( function ( paragraph ) {
					paragraph.style.fontSize = fontSize + 'px';
				} );
		}

		window.addEventListener( 'resize', updateTileText );
		updateTileText();
	}
} );
